(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-cart"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__mgHeaderActionsBound) return;
  window.__mgHeaderActionsBound = true;

  var previousFocus = null;

  function triggers() {
    return document.querySelectorAll('[data-mg-popup-open]');
  }

  function setExpanded(value) {
    triggers().forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', value);
    });
  }

  function restoreFocus() {
    if (previousFocus && previousFocus.focus) previousFocus.focus();
  }

  function openNewsletter(trigger) {
    var root = document.querySelector('.mg-email-popup-shell');
    if (!root) return;

    previousFocus = trigger;
    setExpanded('true');
    root.hidden = false;

    requestAnimationFrame(function () {
      root.classList.add('is-open');
      document.body.classList.add('mg-email-popup-open');

      setTimeout(function () {
        var input = root.querySelector('input[type="email"]');
        var dialog = root.querySelector('[data-mg-popup-dialog]');
        if (input) input.focus();
        else if (dialog) dialog.focus();
      }, 80);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mg-popup-open]');
    if (trigger) {
      event.preventDefault();
      openNewsletter(trigger);
      return;
    }

    if (event.target.closest('[data-mg-popup-close]')) {
      setExpanded('false');
      setTimeout(restoreFocus, 240);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (!document.querySelector('.mg-email-popup-shell.is-open')) return;
    setExpanded('false');
    setTimeout(restoreFocus, 240);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
